// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-desktop-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 166px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 20, 0.12);
  background: var(--header-color-background);
}
.header-desktop-container.header-desktop-checkout-container {
  height: 64px !important;
}
.header-desktop-container.header-desktop-checkout-container .back-to-cart .btn {
  display: flex;
  align-items: center;
  color: var(--header-color-menu-text) !important;
}
.header-desktop-container.header-desktop-checkout-container .back-to-cart .btn:hover {
  filter: brightness(1.25);
}
.header-desktop-container.header-desktop-checkout-container .back-to-cart .icon {
  color: var(--header-color-menu-text);
}
.header-desktop-container .header-main-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.header-desktop-container .header-main-content .header-logo {
  margin-right: var(--spacing-regular);
}
.header-desktop-container .header-main-content .header-logo a img {
  max-width: 120px;
  max-height: 50px;
}
.header-desktop-container .header-main-content .header-search {
  position: relative;
  max-width: 100%;
  width: 589px;
  margin-right: var(--spacing-regular);
}
.header-desktop-container .header-main-content .header-search .vert-input {
  border-width: 1px;
}
.header-desktop-container .header-main-content .header-search button {
  background-color: var(--header-color-search-button) !important;
  border-top: 1px solid var(--header-color-border-search-button) !important;
  border-right: 1px solid var(--header-color-border-search-button) !important;
  border-bottom: 1px solid var(--header-color-border-search-button) !important;
  border-radius: 0px 8px 8px 0px !important ;
  box-shadow: none !important;
}
.header-desktop-container .header-main-content .header-search button:hover {
  background-color: var(--header-color-search-button-hover) !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0px 8px 8px 0px !important ;
  border-top: 1px solid var(--header-color-border-search-button) !important;
  border-right: 1px solid var(--header-color-border-search-button) !important;
  border-bottom: 1px solid var(--header-color-border-search-button) !important;
}
.header-desktop-container .header-main-content .header-points {
  margin-right: var(--spacing-regular);
  min-width: auto;
}
.header-desktop-container .header-main-content .header-points .vert-paragraph {
  cursor: pointer;
  padding: 10px;
  line-height: 1;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 14px;
  border-radius: 40px;
  border: 1px solid var(--header-color-points-border);
  color: var(--header-color-menu-text-points);
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
  padding: var(--spacing-extra-small);
}
.header-desktop-container .header-main-content .header-points .vert-button {
  padding: 4px;
  height: auto;
}
.header-desktop-container .header-main-content .header-points .icon-lueye {
  color: var(--header-color-menu-text-points);
}
.header-desktop-container .header-main-content .header-user {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  margin-right: var(--spacing-regular);
  min-width: 147px;
}
.header-desktop-container .header-main-content .header-user .vert-dropdown .vert-dropdown-icon .vert-icon svg {
  width: var(--font-giant);
  height: var(--font-giant);
  fill: var(--color-detached-lighter);
}
.header-desktop-container .header-main-content .header-user .vert-dropdown .vert-dropdown-title {
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--header-color-menu-text);
}
.header-desktop-container .header-main-content .header-user .vert-dropdown .vert-dropdown-title:hover {
  color: var(--header-color-menu-text);
}
.header-desktop-container .header-main-content .header-user .vert-dropdown .vert-dropdown-title:not(:hover) {
  color: var(--header-color-menu-text);
}
.header-desktop-container .header-main-content .header-notifications {
  margin-right: var(--spacing-regular);
}
.header-desktop-container .header-main-content .header-notifications .vert-notifications {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.header-desktop-container .header-main-content .header-notifications .vert-notifications .vert-notification-icon .vert-icon svg {
  width: var(--font-giant);
  height: var(--font-giant);
  fill: var(--header-color-menu-text);
}
.header-desktop-container .header-main-content .header-notifications .vert-notifications .vert-notification-icon .vert-icon svg:hover {
  fill: var(--color-detached);
}
.header-desktop-container .header-main-content .header-checkout {
  cursor: pointer;
  color: var(--header-color-menu-text);
  position: relative;
}
.header-desktop-container .header-main-content .header-checkout .vert-icon svg {
  width: 26px;
  height: 26px;
  transition: all 0.2s ease-in-out;
  fill: var(--color-detached-lighter);
}
.header-desktop-container .header-main-content .header-checkout .vert-icon svg:hover {
  fill: var(--color-detached);
}
.header-desktop-container .header-main-content .header-checkout .vert-header-checkout-badge {
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 12px;
  cursor: pointer;
}
.header-desktop-container .header-main-content .header-checkout .vert-header-checkout-badge .header-checkout-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: var(--font-family);
  font-size: 8px;
  color: var(--color-white);
  background-color: var(--color-error);
  border-radius: 50%;
  width: 12px;
  height: 12px;
  padding: 2px;
}
.vtex-color-fix-vetmax .vert-template-marketplace.vert-search .vert-button.vert-search-button svg:not(.lucide) {
  fill: var(--header-color-search-icon) !important;
  font-size: 18px !important;
}
.vert-template-marketplace .ant-space .ant-space-item .icon-arrow.active {
  color: var(--header-color-search-icon) !important;
}
.header-mobile-container .header-main-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: var(--spacing-small) var(--spacing-regular);
  background-color: var(--header-color-background);
}
@media screen and (max-width: 320px) {
  .header-mobile-container .header-main-content {
    padding: var(--spacing-small) var(--spacing-extra-small);
  }
}
.header-mobile-container .header-main-content .header-menu-icon {
  color: var(--header-color-menu-text);
  padding: var(--spacing-extra-small);
}
@media screen and (max-width: 320px) {
  .header-mobile-container .header-main-content .header-menu-icon {
    padding: var(--spacing-small) calc(var(--spacing-extra-small) / 2);
  }
}
.header-mobile-container .header-main-content .header-menu-icon .vert-icon svg {
  fill: var(--header-color-menu-text);
  width: var(--font-big);
  height: var(--font-big);
}
.header-mobile-container .header-main-content .header-logo img {
  max-width: 80px;
  max-height: 35px;
}
.header-mobile-container .header-main-content .header-search-icon {
  cursor: pointer;
  padding: var(--spacing-extra-small);
  color: var(--header-color-menu-text);
}
@media screen and (max-width: 320px) {
  .header-mobile-container .header-main-content .header-search-icon {
    padding: var(--spacing-extra-small) calc(var(--spacing-extra-small) / 2);
  }
}
.header-mobile-container .header-main-content .header-search-icon .vert-icon svg {
  fill: var(--header-color-menu-text);
  width: var(--font-big);
  height: var(--font-big);
}
.header-mobile-container .header-main-content .header-notifications-icon {
  cursor: pointer;
  padding: var(--spacing-extra-small);
}
@media screen and (max-width: 320px) {
  .header-mobile-container .header-main-content .header-notifications-icon {
    padding: var(--spacing-extra-small) calc(var(--spacing-extra-small) / 2);
  }
}
.header-mobile-container .header-main-content .header-notifications-icon .vert-notifications {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.header-mobile-container .header-main-content .header-notifications-icon .vert-notifications .vert-notification-icon .vert-icon svg {
  width: var(--font-big);
  height: var(--font-big);
  fill: var(--header-color-menu-text);
}
.header-mobile-container .header-main-content .header-notifications-icon .vert-notifications .vert-notification-icon .vert-icon svg:hover {
  fill: var(--color-detached);
}
.header-mobile-container .header-main-content .header-notifications-icon .vert-notifications .vert-notifications-wrapper {
  width: 300px;
  margin-top: 50px;
}
.header-mobile-container .header-main-content .header-checkout-icon {
  cursor: pointer;
  position: relative;
  padding: var(--spacing-extra-small);
  color: var(--header-color-menu-text);
}
@media screen and (max-width: 320px) {
  .header-mobile-container .header-main-content .header-checkout-icon {
    padding: var(--spacing-extra-small) calc(var(--spacing-extra-small) / 2);
  }
}
.header-mobile-container .header-main-content .header-checkout-icon .vert-icon svg {
  width: var(--font-big);
  height: var(--font-big);
  fill: var(--header-color-menu-text);
  transition: all 0.2s ease-in-out;
}
.header-mobile-container .header-main-content .header-checkout-icon .vert-icon svg:hover {
  fill: var(--color-detached);
}
.header-mobile-container .header-main-content .header-checkout-icon .vert-header-checkout-badge {
  position: absolute;
  z-index: 1;
  top: 5px;
  left: 24px;
  cursor: pointer;
}
.header-mobile-container .header-main-content .header-checkout-icon .vert-header-checkout-badge .header-checkout-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: var(--font-family);
  font-size: 8px;
  color: var(--color-white);
  background-color: var(--color-error);
  border-radius: 50%;
  width: 12px;
  height: 12px;
  padding: 2px;
}
.header-mobile-container .header-points-content {
  background: var(--header-color-points-content);
  padding: var(--spacing-extra-small);
  border-top: var(--border-width) solid var(--color-border);
  padding: var(--spacing-small) var(--spacing-regular);
  box-shadow: 0px 4px 8px rgba(0, 0, 20, 0.12);
  background-color: var(--header-color-background);
  margin-bottom: var(--spacing-small);
}
.header-mobile-container .header-points-content .txt-balance-icon {
  color: var(--header-color-text-balance-responsive) !important;
}
.header-mobile-container .header-points-content .txt-balance-label {
  font-weight: 500;
  margin-left: var(--spacing-small);
  color: var(--header-color-menu-text) !important;
}
.header-mobile-container .header-points-content .txt-balance-value {
  color: var(--header-color-text-balance-responsive) !important;
  font-weight: 700;
  margin-left: var(--spacing-extra-small);
}
.header-mobile-container .header-points-content .vert-button {
  padding: 4px;
  height: auto;
  margin-left: 6px;
}
.header-mobile-container .header-points-content .icon-lueye {
  color: var(--header-color-menu-text-points);
}
.header-mobile-search-modal {
  height: 90vh;
  max-width: 100%;
}
.header-mobile-search-modal .ant-modal-content > button {
  height: 20px;
  width: 20px;
}
.header-mobile-search-modal .ant-modal-content > button svg {
  fill: var(--color-detached-lighter);
}
.header-mobile-search-modal .header-mobile-search {
  height: 100vh;
  margin-top: 50px;
  position: relative;
}
.header-mobile-search-modal .header-mobile-search .vert-search .vert-input {
  border-width: 1px;
}
.header-mobile-search-modal .header-mobile-search .vert-search .vert-search-button {
  background-color: var(--header-color-search-button) !important;
  border: 1px solid var(--color-border) !important;
  box-shadow: none !important;
}
.header-mobile-search-modal .header-mobile-search .vert-search .vert-search-button:hover {
  background-color: var(--header-color-search-button-hover) !important;
}
.ant-modal-root .ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.65) !important;
}
.vert-drawer {
  width: 100%;
}
.vert-drawer .header-mobile-menu .ant-drawer-header {
  align-self: flex-end;
  border: none;
  margin: 0px;
  padding-left: var(--spacing-regular);
  padding-right: var(--spacing-regular);
}
.vert-drawer .header-mobile-menu .ant-drawer-header svg {
  fill: var(--header-color-close-button-responsive);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  padding: 0px var(--spacing-regular) var(--spacing-small) var(--spacing-regular);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .vert-paragraph,
.vert-drawer .header-mobile-menu .header-mobile-menu-content .accordion-label {
  font-family: var(--font-family) !important;
  font-size: var(--font-paragraph) !important;
  line-height: var(--font-paragraph) !important;
  font-weight: 400 !important;
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-profile {
  margin-bottom: var(--spacing-small);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-profile .header-profile-name {
  display: flex;
  align-items: center;
  gap: 5px;
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-profile .header-profile-name .vert-paragraph {
  color: var(--color-neutral-dark);
  font-family: var(--font-family);
  line-height: 120%;
  margin: 0;
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-profile .header-profile-name .vert-icon svg {
  fill: var(--color-neutral-dark);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-profile .header-profile-points {
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 40px;
  transition: all 0.2s ease-in-out;
  color: var(--color-neutral-dark);
  font-size: var(--font-paragraph);
  line-height: var(--font-paragraph);
  margin-top: var(--spacing-extra-small);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-profile .header-profile-points .vert-paragraph {
  font-family: var(--font-family);
  font-weight: 500;
  margin: 0;
  line-height: 120%;
  color: var(--color-neutral-dark);
  font-size: var(--font-medium);
  line-height: var(--font-medium);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-profile .header-profile-points .vert-button {
  padding: 4px;
  height: auto;
  margin-left: 6px;
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-profile .header-profile-points .icon-lueye {
  color: var(--color-neutral-dark);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items {
  border-top: var(--border-width) solid var(--color-border);
  padding-top: var(--spacing-regular);
  line-height: 120%;
  margin: 0;
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .accordion-header {
  font-weight: 500;
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .accordion-header svg {
  color: var(--color-neutral-dark);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .content-content-items {
  padding-top: var(--spacing-extra-small);
  padding-bottom: var(--spacing-extra-small);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .content-content-items .accordion-item {
  display: flex;
  min-width: 312px;
  width: 100%;
  padding: var(--spacing-small) 0px var(--spacing-small) 10vw;
  align-items: flex-start;
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .content-content-items .accordion-item a {
  color: var(--color-neutral-dark);
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .content-content-items .accordion-item a[data-label='Mostrar todas'],
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .content-content-items .accordion-item a[data-label='Ver todas'],
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .content-content-items .accordion-item a[data-label='Mostrar todos'],
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .content-content-items .accordion-item a[data-label='Ver todos'] {
  text-decoration: underline;
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items .content-content-items .accordion-item:last-child {
  padding-bottom: 0px !important;
}
.vert-drawer .header-mobile-menu .header-mobile-menu-content .header-mobile-menu-items > a {
  color: var(--color-neutral-dark);
}
.vert-template-marketplace.vert-notifications .vert-notification-icon {
  display: flex;
  flex-direction: column;
  color: var(--header-color-menu-text) !important;
}
.vert-template-marketplace.vert-icon.ant-icon-color-highlight svg,
.vert-template-marketplace .vert-icon.ant-icon-color-highlight svg {
  fill: var(--header-color-close-button-responsive) !important;
}
.header-user .color-default,
.header-user .ant-typography-default,
.header-user .color-neutral-dark {
  color: var(--header-color-icon-participant-info) !important;
}
.header-checkout-color-typography {
  color: var(--color-detached) !important;
}
.header-desktop-container-fixed {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 166px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 20, 0.12);
  background: var(--header-color-background);
  position: fixed;
  z-index: 100;
}
.header-desktop-container-fixed.header-desktop-checkout-container {
  height: 64px !important;
}
.header-desktop-container-fixed .header-main-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.header-desktop-container-fixed .header-main-content .header-logo {
  margin-right: var(--spacing-regular);
}
.header-desktop-container-fixed .header-main-content .header-logo a img {
  max-width: 120px;
  max-height: 50px;
}
.header-desktop-container-fixed .header-main-content .header-search {
  position: relative;
  max-width: 100%;
  width: 589px;
  margin-right: var(--spacing-regular);
}
.header-desktop-container-fixed .header-main-content .header-search .vert-input {
  border-width: 1px;
}
.header-desktop-container-fixed .header-main-content .header-search button {
  background-color: var(--header-color-search-button) !important;
  border-top: 1px solid var(--header-color-border-search-button) !important;
  border-right: 1px solid var(--header-color-border-search-button) !important;
  border-bottom: 1px solid var(--header-color-border-search-button) !important;
  border-radius: 0px 8px 8px 0px !important ;
  box-shadow: none !important;
}
.header-desktop-container-fixed .header-main-content .header-search button:hover {
  background-color: var(--header-color-search-button-hover) !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0px 8px 8px 0px !important ;
  border-top: 1px solid var(--header-color-border-search-button) !important;
  border-right: 1px solid var(--header-color-border-search-button) !important;
  border-bottom: 1px solid var(--header-color-border-search-button) !important;
}
.header-desktop-container-fixed .header-main-content .header-points {
  margin-right: var(--spacing-regular);
  min-width: auto;
}
.header-desktop-container-fixed .header-main-content .header-points .vert-paragraph {
  cursor: pointer;
  padding: 10px;
  line-height: 1;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 14px;
  border-radius: 40px;
  border: 1px solid var(--header-color-points-border);
  color: var(--header-color-menu-text-points);
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
  padding: var(--spacing-extra-small);
}
.header-desktop-container-fixed .header-main-content .header-points .vert-button {
  padding: 4px;
  height: auto;
}
.header-desktop-container-fixed .header-main-content .header-points .icon-lueye {
  color: var(--header-color-menu-text-points);
}
.header-desktop-container-fixed .header-main-content .header-user {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  margin-right: var(--spacing-regular);
  min-width: 147px;
}
.header-desktop-container-fixed .header-main-content .header-user .vert-dropdown .vert-dropdown-icon .vert-icon svg {
  width: var(--font-giant);
  height: var(--font-giant);
  fill: var(--color-detached-lighter);
}
.header-desktop-container-fixed .header-main-content .header-user .vert-dropdown .vert-dropdown-title {
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--header-color-menu-text);
}
.header-desktop-container-fixed .header-main-content .header-user .vert-dropdown .vert-dropdown-title:hover {
  color: var(--header-color-menu-text);
}
.header-desktop-container-fixed .header-main-content .header-user .vert-dropdown .vert-dropdown-title:not(:hover) {
  color: var(--header-color-menu-text);
}
.header-desktop-container-fixed .header-main-content .header-notifications {
  margin-right: var(--spacing-regular);
}
.header-desktop-container-fixed .header-main-content .header-notifications .vert-notifications {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.header-desktop-container-fixed .header-main-content .header-notifications .vert-notifications .vert-notification-icon .vert-icon svg {
  width: var(--font-giant);
  height: var(--font-giant);
  fill: var(--header-color-menu-text);
}
.header-desktop-container-fixed .header-main-content .header-notifications .vert-notifications .vert-notification-icon .vert-icon svg:hover {
  fill: var(--color-detached);
}
.header-desktop-container-fixed .header-main-content .header-checkout {
  cursor: pointer;
  color: var(--header-color-menu-text);
  position: relative;
}
.header-desktop-container-fixed .header-main-content .header-checkout .vert-icon svg {
  width: 26px;
  height: 26px;
  transition: all 0.2s ease-in-out;
  fill: var(--color-detached-lighter);
}
.header-desktop-container-fixed .header-main-content .header-checkout .vert-icon svg:hover {
  fill: var(--color-detached);
}
.header-desktop-container-fixed .header-main-content .header-checkout .vert-header-checkout-badge {
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 12px;
  cursor: pointer;
}
.header-desktop-container-fixed .header-main-content .header-checkout .vert-header-checkout-badge .header-checkout-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: var(--font-family);
  font-size: 8px;
  color: var(--color-white);
  background-color: var(--color-error);
  border-radius: 50%;
  width: 12px;
  height: 12px;
  padding: 2px;
}
.Wall {
  height: 166px;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Header/HeaderStyles.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,4CAAA;EACA,0CAAA;AAAF;AAEE;EACE,uBAAA;AAAJ;AADE;EAKM,aAAA;EACA,mBAAA;EAEA,+CAAA;AAFR;AAIQ;EACE,wBAAA;AAFV;AATE;EAgBM,oCAAA;AAJR;AArBA;EA+BI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAPJ;AA3BA;EAoCM,oCAAA;AANN;AA9BA;EAuCU,gBAAA;EACA,gBAAA;AANV;AAlCA;EA6CM,kBAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;AARN;AAxCA;EAkDQ,iBAAA;AAPR;AA3CA;EAsDQ,8DAAA;EAGA,yEAAA;EACA,2EAAA;EACA,4EAAA;EACA,0CAAA;EAEA,2BAAA;AAXR;AAaQ;EACE,oEAAA;EACA,uBAAA;EACA,2BAAA;EACA,0CAAA;EACA,yEAAA;EACA,2EAAA;EACA,4EAAA;AAXV;AA5DA;EA6EM,oCAAA;EACA,eAAA;AAdN;AAhEA;EAiFQ,eAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,mDAAA;EACA,2CAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mCAAA;AAdR;AAjFA;EAmGQ,YAAA;EACA,YAAA;AAfR;AArFA;EAwGQ,2CAAA;AAhBR;AAxFA;EA6GM,aAAA;EACA,sBAAA;EACA,eAAA;EACA,oCAAA;EAEA,gBAAA;AAnBN;AA/FA;EAwHc,wBAAA;EACA,yBAAA;EACA,mCAAA;AAtBd;AApGA;EA+HU,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,oCAAA;AAxBV;AA0BU;EACE,oCAAA;AAxBZ;AA2BU;EACE,oCAAA;AAzBZ;AAhHA;EAgJM,oCAAA;AA7BN;AAnHA;EAkJQ,aAAA;EACA,sBAAA;EACA,qBAAA;AA5BR;AAxHA;EAyJc,wBAAA;EACA,yBAAA;EACA,mCAAA;AA9Bd;AA+Bc;EACE,2BAAA;AA7BhB;AAhIA;EAsKM,eAAA;EACA,oCAAA;EACA,kBAAA;AAnCN;AArIA;EA4KU,WAAA;EACA,YAAA;EACA,gCAAA;EACA,mCAAA;AApCV;AAqCU;EACE,2BAAA;AAnCZ;AA9IA;EAsLQ,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AArCR;AArJA;EA6LU,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AArCV;AA2CA;EAII,gDAAA;EACA,0BAAA;AA5CJ;AAgDA;EACE,iDAAA;AA9CF;AAkDA;EAEI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,oDAAA;EACA,gDAAA;AAjDJ;AAkDI;EAAA;IACE,wDAAA;EA/CJ;AACF;AAqCA;EAYM,oCAAA;EACA,mCAAA;AA9CN;AA+CM;EAAA;IACE,kEAAA;EA5CN;AACF;AA4BA;EAmBU,mCAAA;EACA,sBAAA;EACA,uBAAA;AA5CV;AAuBA;EA4BQ,eAAA;EACA,gBAAA;AAhDR;AAmBA;EAkCM,eAAA;EACA,mCAAA;EACA,oCAAA;AAlDN;AAmDM;EAAA;IACE,wEAAA;EAhDN;AACF;AASA;EA0CU,mCAAA;EACA,sBAAA;EACA,uBAAA;AAhDV;AAIA;EAkDM,eAAA;EACA,mCAAA;AAnDN;AAoDM;EAAA;IACE,wEAAA;EAjDN;AACF;AALA;EAwDQ,aAAA;EACA,sBAAA;EACA,qBAAA;AAhDR;AAVA;EA+Dc,sBAAA;EACA,uBAAA;EACA,mCAAA;AAlDd;AAmDc;EACE,2BAAA;AAjDhB;AAlBA;EA0EU,YAAA;EACA,gBAAA;AArDV;AAtBA;EAiFM,eAAA;EACA,kBAAA;EACA,mCAAA;EACA,oCAAA;AAxDN;AAyDM;EAAA;IACE,wEAAA;EAtDN;AACF;AAjCA;EA0FU,sBAAA;EACA,uBAAA;EACA,mCAAA;EACA,gCAAA;AAtDV;AAuDU;EACE,2BAAA;AArDZ;AA1CA;EAqGQ,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAxDR;AAjDA;EA4GU,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAxDV;AA/DA;EA6HI,8CAAA;EACA,mCAAA;EACA,yDAAA;EACA,oDAAA;EACA,4CAAA;EACA,gDAAA;EACA,mCAAA;AA3DJ;AAxEA;EAsIM,6DAAA;AA3DN;AA3EA;EAyIM,gBAAA;EACA,iCAAA;EACA,+CAAA;AA3DN;AAhFA;EA8IM,6DAAA;EACA,gBAAA;EACA,uCAAA;AA3DN;AArFA;EAoJM,YAAA;EACA,YAAA;EACA,gBAAA;AA5DN;AA1FA;EA0JM,2CAAA;AA7DN;AAkEA;EACE,YAAA;EACA,eAAA;AAhEF;AA8DA;EAMM,YAAA;EACA,WAAA;AAjEN;AA0DA;EASQ,mCAAA;AAhER;AAuDA;EAeI,aAAA;EACA,gBAAA;EACA,kBAAA;AAnEJ;AAkDA;EAoBQ,iBAAA;AAnER;AA+CA;EAwBQ,8DAAA;EACA,gDAAA;EACA,2BAAA;AApER;AAsEQ;EACE,oEAAA;AApEV;AA2EA;EAEI,gDAAA;AA1EJ;AA8EA;EACE,WAAA;AA5EF;AA2EA;EAIM,oBAAA;EACA,YAAA;EACA,WAAA;EAEA,oCAAA;EACA,qCAAA;AA7EN;AAoEA;EAYQ,iDAAA;AA7ER;AAiEA;EAiBM,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,+EAAA;AA/EN;AA2DA;;EAyBQ,0CAAA;EACA,2CAAA;EACA,6CAAA;EACA,2BAAA;AAhFR;AAoDA;EAgCQ,mCAAA;AAjFR;AAiDA;EAkCU,aAAA;EACA,mBAAA;EACA,QAAA;AAhFV;AA4CA;EAuCY,gCAAA;EACA,+BAAA;EACA,iBAAA;EACA,SAAA;AAhFZ;AAsCA;EA+Cc,+BAAA;AAlFd;AAmCA;EAqDU,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gCAAA;EAEA,gCAAA;EACA,gCAAA;EACA,kCAAA;EACA,sCAAA;AAtFV;AAwBA;EAiEY,+BAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,6BAAA;EACA,+BAAA;AAtFZ;AAeA;EA2EY,YAAA;EACA,YAAA;EACA,gBAAA;AAvFZ;AAUA;EAiFY,gCAAA;AAxFZ;AAOA;EAuFQ,yDAAA;EACA,mCAAA;EAEA,iBAAA;EACA,SAAA;AA5FR;AACA;EA8FU,gBAAA;AA5FV;AAFA;EAiGY,gCAAA;AA5FZ;AALA;EAsGU,uCAAA;EACA,0CAAA;AA9FV;AATA;EA0GY,aAAA;EACA,gBAAA;EACA,WAAA;EACA,2DAAA;EACA,uBAAA;AA9FZ;AAhBA;EAgHc,gCAAA;AA7Fd;AA8Fc;;;;EAIE,0BAAA;AA5FhB;AAgGY;EACE,8BAAA;AA9Fd;AA5BA;EAgIU,gCAAA;AAjGV;AAwGA;EACE,aAAA;EACA,sBAAA;EACA,+CAAA;AAtGF;AAyGA;;EAEE,4DAAA;AAvGF;AA0GA;;;EAII,2DAAA;AAzGJ;AA6GA;EACE,uCAAA;AA3GF;AA8GA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,4CAAA;EACA,0CAAA;EACA,eAAA;EACA,YAAA;AA5GF;AA8GE;EACE,uBAAA;AA5GJ;AAgGA;EAgBI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AA7GJ;AA0FA;EAqBM,oCAAA;AA5GN;AAuFA;EAwBU,gBAAA;EACA,gBAAA;AA5GV;AAmFA;EA8BM,kBAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;AA9GN;AA6EA;EAmCQ,iBAAA;AA7GR;AA0EA;EAuCQ,8DAAA;EAGA,yEAAA;EACA,2EAAA;EACA,4EAAA;EACA,0CAAA;EAEA,2BAAA;AAjHR;AAmHQ;EACE,oEAAA;EACA,uBAAA;EACA,2BAAA;EACA,0CAAA;EACA,yEAAA;EACA,2EAAA;EACA,4EAAA;AAjHV;AAyDA;EA8DM,oCAAA;EACA,eAAA;AApHN;AAqDA;EAkEQ,eAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,mDAAA;EACA,2CAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mCAAA;AApHR;AAoCA;EAoFQ,YAAA;EACA,YAAA;AArHR;AAgCA;EAyFQ,2CAAA;AAtHR;AA6BA;EA8FM,aAAA;EACA,sBAAA;EACA,eAAA;EACA,oCAAA;EAEA,gBAAA;AAzHN;AAsBA;EAyGc,wBAAA;EACA,yBAAA;EACA,mCAAA;AA5Hd;AAiBA;EAgHU,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,oCAAA;AA9HV;AAgIU;EACE,oCAAA;AA9HZ;AAiIU;EACE,oCAAA;AA/HZ;AAKA;EAiIM,oCAAA;AAnIN;AAEA;EAmIQ,aAAA;EACA,sBAAA;EACA,qBAAA;AAlIR;AAHA;EA0Ic,wBAAA;EACA,yBAAA;EACA,mCAAA;AApId;AAqIc;EACE,2BAAA;AAnIhB;AAXA;EAuJM,eAAA;EACA,oCAAA;EACA,kBAAA;AAzIN;AAhBA;EA6JU,WAAA;EACA,YAAA;EACA,gCAAA;EACA,mCAAA;AA1IV;AA2IU;EACE,2BAAA;AAzIZ;AAzBA;EAuKQ,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AA3IR;AAhCA;EA8KU,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA3IV;AAiJA;EAEE,aAAA;AAhJF","sourcesContent":["// DESKTOP\n.header-desktop-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  height: 166px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 20, 0.12);\n  background: var(--header-color-background);\n\n  &.header-desktop-checkout-container {\n    height: 64px !important;\n\n    .back-to-cart {\n      .btn {\n        display: flex;\n        align-items: center;\n\n        color: var(--header-color-menu-text) !important;\n\n        &:hover {\n          filter: brightness(1.25);\n        }\n      }\n\n      .icon {\n        color: var(--header-color-menu-text);\n      }\n    }\n  }\n\n  .header-main-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    .header-logo {\n      margin-right: var(--spacing-regular);\n      a {\n        img {\n          max-width: 120px;\n          max-height: 50px;\n        }\n      }\n    }\n    .header-search {\n      position: relative;\n      max-width: 100%;\n      width: 589px;\n      margin-right: var(--spacing-regular);\n      .vert-input {\n        border-width: 1px;\n      }\n\n      button {\n        background-color: var(--header-color-search-button) !important;\n\n        box-shadow: none !important;\n        border-top: 1px solid var(--header-color-border-search-button) !important;\n        border-right: 1px solid var(--header-color-border-search-button) !important;\n        border-bottom: 1px solid var(--header-color-border-search-button) !important;\n        border-radius: 0px 8px 8px 0px !important ;\n\n        box-shadow: none !important;\n\n        &:hover {\n          background-color: var(--header-color-search-button-hover) !important;\n          border: none !important;\n          box-shadow: none !important;\n          border-radius: 0px 8px 8px 0px !important ;\n          border-top: 1px solid var(--header-color-border-search-button) !important;\n          border-right: 1px solid var(--header-color-border-search-button) !important;\n          border-bottom: 1px solid var(--header-color-border-search-button) !important;\n        }\n      }\n    }\n\n    .header-points {\n      margin-right: var(--spacing-regular);\n      min-width: auto;\n\n      .vert-paragraph {\n        cursor: pointer;\n        padding: 10px;\n        line-height: 1;\n        margin-bottom: 0;\n        font-weight: 500;\n        font-size: 14px;\n        border-radius: 40px;\n        border: 1px solid var(--header-color-points-border);\n        color: var(--header-color-menu-text-points);\n        transition: all 0.2s ease-in-out;\n        white-space: nowrap;\n        display: flex;\n        align-items: center;\n        gap: var(--spacing-extra-small); \n        padding: var(--spacing-extra-small);\n      }\n\n      .vert-button{\n        padding: 4px;\n        height: auto;\n      }\n\n      .icon-lueye{\n        color: var(--header-color-menu-text-points);\n      }\n    }\n\n    .header-user {\n      display: flex;\n      flex-direction: column;\n      cursor: pointer;\n      margin-right: var(--spacing-regular);\n\n      min-width: 147px;\n\n      .vert-dropdown {\n        .vert-dropdown-icon {\n          .vert-icon {\n            svg {\n              width: var(--font-giant);\n              height: var(--font-giant);\n              fill: var(--color-detached-lighter);\n            }\n          }\n        }\n        .vert-dropdown-title {\n          font-family: var(--font-family);\n          font-size: var(--font-paragraph);\n          font-weight: 500;\n          color: var(--header-color-menu-text);\n\n          &:hover {\n            color: var(--header-color-menu-text);\n          }\n\n          &:not(:hover) {\n            color: var(--header-color-menu-text);\n          }\n        }\n      }\n    }\n\n    .header-notifications {\n      margin-right: var(--spacing-regular);\n      .vert-notifications {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n\n        .vert-notification-icon {\n          .vert-icon {\n            svg {\n              width: var(--font-giant);\n              height: var(--font-giant);\n              fill: var(--header-color-menu-text);\n              &:hover {\n                fill: var(--color-detached);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .header-checkout {\n      cursor: pointer;\n      color: var(--header-color-menu-text);\n      position: relative;\n\n      .vert-icon {\n        svg {\n          width: 26px;\n          height: 26px;\n          transition: all 0.2s ease-in-out;\n          fill: var(--color-detached-lighter);\n          &:hover {\n            fill: var(--color-detached);\n          }\n        }\n      }\n      .vert-header-checkout-badge {\n        position: absolute;\n        z-index: 1;\n        top: -5px;\n        left: 12px;\n        cursor: pointer;\n\n        .header-checkout-badge {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          font-family: var(--font-family);\n          font-size: 8px;\n          color: var(--color-white);\n          background-color: var(--color-error);\n          border-radius: 50%;\n          width: 12px;\n          height: 12px;\n          padding: 2px;\n        }\n      }\n    }\n  }\n}\n.vtex-color-fix-vetmax {\n  .vert-template-marketplace.vert-search\n    .vert-button.vert-search-button\n    svg:not(.lucide) {\n    fill: var(--header-color-search-icon) !important;\n    font-size: 18px !important;\n  }\n}\n\n.vert-template-marketplace .ant-space .ant-space-item .icon-arrow.active {\n  color: var(--header-color-search-icon) !important;\n}\n\n// MOBILE\n.header-mobile-container {\n  .header-main-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: var(--spacing-small) var(--spacing-regular);\n    background-color: var(--header-color-background);\n    @media screen and (max-width: 320px) {\n      padding: var(--spacing-small) var(--spacing-extra-small);\n    }\n    .header-menu-icon {\n      color: var(--header-color-menu-text);\n      padding: var(--spacing-extra-small);\n      @media screen and (max-width: 320px) {\n        padding: var(--spacing-small) calc(var(--spacing-extra-small) / 2);\n      }\n      .vert-icon {\n        svg {\n          fill: var(--header-color-menu-text);\n          width: var(--font-big);\n          height: var(--font-big);\n        }\n      }\n    }\n\n    .header-logo {\n      img {\n        max-width: 80px;\n        max-height: 35px;\n      }\n    }\n\n    .header-search-icon {\n      cursor: pointer;\n      padding: var(--spacing-extra-small);\n      color: var(--header-color-menu-text);\n      @media screen and (max-width: 320px) {\n        padding: var(--spacing-extra-small) calc(var(--spacing-extra-small) / 2);\n      }\n      .vert-icon {\n        svg {\n          fill: var(--header-color-menu-text);\n          width: var(--font-big);\n          height: var(--font-big);\n        }\n      }\n    }\n\n    .header-notifications-icon {\n      cursor: pointer;\n      padding: var(--spacing-extra-small);\n      @media screen and (max-width: 320px) {\n        padding: var(--spacing-extra-small) calc(var(--spacing-extra-small) / 2);\n      }\n      .vert-notifications {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n\n        .vert-notification-icon {\n          .vert-icon {\n            svg {\n              width: var(--font-big);\n              height: var(--font-big);\n              fill: var(--header-color-menu-text);\n              &:hover {\n                fill: var(--color-detached);\n              }\n            }\n          }\n        }\n\n        .vert-notifications-wrapper {\n          width: 300px;\n          margin-top: 50px;\n        }\n      }\n    }\n\n    .header-checkout-icon {\n      cursor: pointer;\n      position: relative;\n      padding: var(--spacing-extra-small);\n      color: var(--header-color-menu-text);\n      @media screen and (max-width: 320px) {\n        padding: var(--spacing-extra-small) calc(var(--spacing-extra-small) / 2);\n      }\n      .vert-icon {\n        svg {\n          width: var(--font-big);\n          height: var(--font-big);\n          fill: var(--header-color-menu-text);\n          transition: all 0.2s ease-in-out;\n          &:hover {\n            fill: var(--color-detached);\n          }\n        }\n      }\n\n      .vert-header-checkout-badge {\n        position: absolute;\n        z-index: 1;\n        top: 5px;\n        left: 24px;\n        cursor: pointer;\n\n        .header-checkout-badge {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          font-family: var(--font-family);\n          font-size: 8px;\n          color: var(--color-white);\n          background-color: var(--color-error);\n          border-radius: 50%;\n          width: 12px;\n          height: 12px;\n          padding: 2px;\n        }\n      }\n    }\n  }\n  .header-points-content {\n    background: var(--header-color-points-content);\n    padding: var(--spacing-extra-small);\n    border-top: var(--border-width) solid var(--color-border);\n    padding: var(--spacing-small) var(--spacing-regular);\n    box-shadow: 0px 4px 8px rgba(0, 0, 20, 0.12);\n    background-color: var(--header-color-background);\n    margin-bottom: var(--spacing-small);\n\n    .txt-balance-icon {\n      color: var(--header-color-text-balance-responsive) !important;\n    }\n    .txt-balance-label {\n      font-weight: 500;\n      margin-left: var(--spacing-small);\n      color: var(--header-color-menu-text) !important;\n    }\n    .txt-balance-value {\n      color: var(--header-color-text-balance-responsive) !important;\n      font-weight: 700;\n      margin-left: var(--spacing-extra-small);\n    }\n\n    .vert-button {\n      padding: 4px;\n      height: auto;\n      margin-left: 6px;\n    }\n\n    .icon-lueye{\n      color:var(--header-color-menu-text-points);\n    }\n  }\n}\n\n.header-mobile-search-modal {\n  height: 90vh;\n  max-width: 100%;\n\n  .ant-modal-content {\n    > button {\n      height: 20px;\n      width: 20px;\n      svg {\n        fill: var(--color-detached-lighter);\n      }\n    }\n  }\n\n  .header-mobile-search {\n    height: 100vh;\n    margin-top: 50px;\n    position: relative;\n    .vert-search {\n      .vert-input {\n        border-width: 1px;\n      }\n\n      .vert-search-button {\n        background-color: var(--header-color-search-button) !important;\n        border: 1px solid var(--color-border) !important;\n        box-shadow: none !important;\n\n        &:hover {\n          background-color: var(--header-color-search-button-hover) !important;\n        }\n      }\n    }\n  }\n}\n\n.ant-modal-root {\n  .ant-modal-mask {\n    background-color: rgba(0, 0, 0, 0.65) !important;\n  }\n}\n\n.vert-drawer {\n  width: 100%;\n  .header-mobile-menu {\n    .ant-drawer-header {\n      align-self: flex-end;\n      border: none;\n      margin: 0px;\n\n      padding-left: var(--spacing-regular);\n      padding-right: var(--spacing-regular);\n\n      svg {\n        fill: var(--header-color-close-button-responsive);\n      }\n    }\n\n    .header-mobile-menu-content {\n      display: flex;\n      flex-direction: column;\n      gap: var(--spacing-regular);\n      padding: 0px var(--spacing-regular) var(--spacing-small)\n        var(--spacing-regular);\n\n      .vert-paragraph,\n      .accordion-label {\n        font-family: var(--font-family) !important;\n        font-size: var(--font-paragraph) !important;\n        line-height: var(--font-paragraph) !important;\n        font-weight: 400 !important;\n      }\n\n      .header-profile {\n        margin-bottom: var(--spacing-small);\n        .header-profile-name {\n          display: flex;\n          align-items: center;\n          gap: 5px;\n\n          .vert-paragraph {\n            color: var(--color-neutral-dark);\n            font-family: var(--font-family);\n            line-height: 120%;\n            margin: 0;\n          }\n\n          .vert-icon {\n            svg {\n              fill: var(--color-neutral-dark);\n            }\n          }\n        }\n\n        .header-profile-points {\n          display: flex;\n          align-items: center;\n          gap: 5px;\n          border-radius: 40px;\n          transition: all 0.2s ease-in-out;\n\n          color: var(--color-neutral-dark);\n          font-size: var(--font-paragraph);\n          line-height: var(--font-paragraph);\n          margin-top: var(--spacing-extra-small);\n\n          .vert-paragraph {\n            font-family: var(--font-family);\n            font-weight: 500;\n            margin: 0;\n            line-height: 120%;\n            color: var(--color-neutral-dark);\n            font-size: var(--font-medium);\n            line-height: var(--font-medium);\n          }\n\n          .vert-button {\n            padding: 4px;\n            height: auto;\n            margin-left: 6px;\n          }\n\n          .icon-lueye{\n            color: var(--color-neutral-dark);\n          }\n        }\n      }\n\n      .header-mobile-menu-items {\n        border-top: var(--border-width) solid var(--color-border);\n        padding-top: var(--spacing-regular);\n\n        line-height: 120%;\n        margin: 0;\n\n        .accordion-header {\n          font-weight: 500;\n\n          svg {\n            color: var(--color-neutral-dark);\n          }\n        }\n\n        .content-content-items {\n          padding-top: var(--spacing-extra-small);\n          padding-bottom: var(--spacing-extra-small);\n\n          .accordion-item {\n            display: flex;\n            min-width: 312px;\n            width: 100%;\n            padding: var(--spacing-small) 0px var(--spacing-small) 10vw;\n            align-items: flex-start;\n            a {\n              color: var(--color-neutral-dark);\n              &[data-label='Mostrar todas'],\n              &[data-label='Ver todas'],\n              &[data-label='Mostrar todos'],\n              &[data-label='Ver todos'] {\n                text-decoration: underline;\n              }\n            }\n\n            &:last-child {\n              padding-bottom: 0px !important;\n            }\n          }\n        }\n\n        > a {\n          color: var(--color-neutral-dark);\n        }\n      }\n    }\n  }\n}\n\n.vert-template-marketplace.vert-notifications .vert-notification-icon {\n  display: flex;\n  flex-direction: column;\n  color: var(--header-color-menu-text) !important;\n}\n\n.vert-template-marketplace.vert-icon.ant-icon-color-highlight svg,\n.vert-template-marketplace .vert-icon.ant-icon-color-highlight svg {\n  fill: var(--header-color-close-button-responsive) !important;\n}\n\n.header-user {\n  .color-default,\n  .ant-typography-default,\n  .color-neutral-dark {\n    color: var(--header-color-icon-participant-info) !important;\n  }\n}\n\n.header-checkout-color-typography {\n  color: var(--color-detached) !important;\n}\n\n.header-desktop-container-fixed {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  height: 166px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 20, 0.12);\n  background: var(--header-color-background);\n  position: fixed;\n  z-index: 100;\n\n  &.header-desktop-checkout-container {\n    height: 64px !important;\n  }\n\n  .header-main-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    .header-logo {\n      margin-right: var(--spacing-regular);\n      a {\n        img {\n          max-width: 120px;\n          max-height: 50px;\n        }\n      }\n    }\n    .header-search {\n      position: relative;\n      max-width: 100%;\n      width: 589px;\n      margin-right: var(--spacing-regular);\n      .vert-input {\n        border-width: 1px;\n      }\n\n      button {\n        background-color: var(--header-color-search-button) !important;\n\n        box-shadow: none !important;\n        border-top: 1px solid var(--header-color-border-search-button) !important;\n        border-right: 1px solid var(--header-color-border-search-button) !important;\n        border-bottom: 1px solid var(--header-color-border-search-button) !important;\n        border-radius: 0px 8px 8px 0px !important ;\n\n        box-shadow: none !important;\n\n        &:hover {\n          background-color: var(--header-color-search-button-hover) !important;\n          border: none !important;\n          box-shadow: none !important;\n          border-radius: 0px 8px 8px 0px !important ;\n          border-top: 1px solid var(--header-color-border-search-button) !important;\n          border-right: 1px solid var(--header-color-border-search-button) !important;\n          border-bottom: 1px solid var(--header-color-border-search-button) !important;\n        }\n      }\n    }\n\n    .header-points {\n      margin-right: var(--spacing-regular);\n      min-width: auto;\n\n      .vert-paragraph {\n        cursor: pointer;\n        padding: 10px;\n        line-height: 1;\n        margin-bottom: 0;\n        font-weight: 500;\n        font-size: 14px;\n        border-radius: 40px;\n        border: 1px solid var(--header-color-points-border);\n        color: var(--header-color-menu-text-points);\n        transition: all 0.2s ease-in-out;\n        white-space: nowrap;\n        display: flex;\n        align-items: center;\n        gap: var(--spacing-extra-small); \n        padding: var(--spacing-extra-small);\n      }\n\n      .vert-button{\n        padding: 4px;\n        height: auto;\n      }\n\n      .icon-lueye{\n        color: var(--header-color-menu-text-points);\n      }\n    }\n\n    .header-user {\n      display: flex;\n      flex-direction: column;\n      cursor: pointer;\n      margin-right: var(--spacing-regular);\n\n      min-width: 147px;\n\n      .vert-dropdown {\n        .vert-dropdown-icon {\n          .vert-icon {\n            svg {\n              width: var(--font-giant);\n              height: var(--font-giant);\n              fill: var(--color-detached-lighter);\n            }\n          }\n        }\n        .vert-dropdown-title {\n          font-family: var(--font-family);\n          font-size: var(--font-paragraph);\n          font-weight: 500;\n          color: var(--header-color-menu-text);\n\n          &:hover {\n            color: var(--header-color-menu-text);\n          }\n\n          &:not(:hover) {\n            color: var(--header-color-menu-text);\n          }\n        }\n      }\n    }\n\n    .header-notifications {\n      margin-right: var(--spacing-regular);\n      .vert-notifications {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n\n        .vert-notification-icon {\n          .vert-icon {\n            svg {\n              width: var(--font-giant);\n              height: var(--font-giant);\n              fill: var(--header-color-menu-text);\n              &:hover {\n                fill: var(--color-detached);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .header-checkout {\n      cursor: pointer;\n      color: var(--header-color-menu-text);\n      position: relative;\n\n      .vert-icon {\n        svg {\n          width: 26px;\n          height: 26px;\n          transition: all 0.2s ease-in-out;\n          fill: var(--color-detached-lighter);\n          &:hover {\n            fill: var(--color-detached);\n          }\n        }\n      }\n      .vert-header-checkout-badge {\n        position: absolute;\n        z-index: 1;\n        top: -5px;\n        left: 12px;\n        cursor: pointer;\n\n        .header-checkout-badge {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          font-family: var(--font-family);\n          font-size: 8px;\n          color: var(--color-white);\n          background-color: var(--color-error);\n          border-radius: 50%;\n          width: 12px;\n          height: 12px;\n          padding: 2px;\n        }\n      }\n    }\n  }\n}\n.Wall\n{\n  height: 166px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
